export default "__VITE_ASSET__Cfjqx4d6__"